<template>
  <div style="width:100vw;">
    <div id="headerbar">
      <div @click="goHome" class="logo">
        <img src="../assets/images/logo_white.png" />
      </div>
      <div class="button-group" v-show="canvasWidth" style="flex:auto;">
        <div class="btn-group">
          <div class="el-btn">
            <button @click="addText">
              <svg class="svg-icon" aria-hidden="true">
                <use xlink:href="#icon-font"></use>
              </svg>
            </button>
            <p>文字</p>
          </div>
          <div class="el-btn">
            <button @click="addImage">
              <svg class="svg-icon" aria-hidden="true">
                <use xlink:href="#icon-img"></use>
              </svg>
            </button>
            <p>图片</p>
          </div>
          <div class="el-btn">
            <button @click="addCanvas">
              <svg class="svg-icon" aria-hidden="true">
                <use xlink:href="#icon-canvas"></use>
              </svg>
            </button>
            <p>添加画布</p>
          </div>
        </div>
        <div class="btn-group">
          <div class="el-btn el-btn-step">
            <button @click="undoAction">
              <svg class="svg-icon" aria-hidden="true">
                <use xlink:href="#icon-previous"></use>
              </svg>
            </button>
            <p>上一步</p>
          </div>
          <div class="el-btn el-btn-step">
            <button @click="redoAction">
              <svg class="svg-icon" aria-hidden="true">
                <use xlink:href="#icon-next"></use>
              </svg>
            </button>
            <p>下一步</p>
          </div>
        </div>
        <div class="btn-group">
          <div class="el-btn el-btn-control">
            <button @click="saveTemplate">
              <svg class="svg-icon" aria-hidden="true">
                <use xlink:href="#icon-save"></use>
              </svg>
            </button>
            <p>保存</p>
          </div>
          <div class="el-btn el-btn-control">
            <button @click="saveAnother">
              <svg class="svg-icon" aria-hidden="true">
                <use xlink:href="#icon-saveas"></use>
              </svg>
            </button>
            <p>另存为</p>
          </div>
          <div class="el-btn el-btn-control">
            <button @click="goHome">
              <svg class="svg-icon" aria-hidden="true">
                <use xlink:href="#icon-return"></use>
              </svg>
            </button>
            <p>返回</p>
          </div>
        </div>
      </div>
      <div style="width:256px;"></div>
    </div>
    <div id="stage">
      <el-tabs tab-position="left">
        <el-tab-pane>
          <span slot="label" class="tabs-title">
            <svg class="svg-icon" aria-hidden="true">
              <use xlink:href="#icon-template"></use></svg
            >模板</span
          >
          <resource-panel />
        </el-tab-pane>
        <el-tab-pane>
          <span slot="label" class="tabs-title">
            <svg class="svg-icon" aria-hidden="true">
              <use xlink:href="#icon-element"></use></svg
            >元素</span
          >
          <element-panel
            :canvasWidth="canvasWidth"
            :canvasHeight="canvasHeight"
          />
        </el-tab-pane>
        <el-tab-pane label="上传">
          <span slot="label" class="tabs-title">
            <svg class="svg-icon" aria-hidden="true">
              <use xlink:href="#icon-upload"></use></svg
            >上传</span
          >
          <user-material-panel
            :canvasWidth="canvasWidth"
            :canvasHeight="canvasHeight"
          />
        </el-tab-pane>
      </el-tabs>
      <div
        id="canvas"
        ref="canvas"
        @mousedown.stop="cancelSelect"
        @mouseleave="cancelClipboard"
        @mouseenter="resumeClipboard"
      >
        <div id="canvas-tab" v-show="keys.length > 1">
          <div
            :class="{ tab: true, active: tab === activeKey }"
            v-for="(tab, index) in keys"
            :key="tab"
            @click="switchCanvas(tab)"
          >
            <span>画布{{ index + 1 }}</span>
            <span class="close" @click.stop="removeCanvas(tab)">x</span>
          </div>
        </div>
        <div
          id="page"
          :style="pageStyle"
          @contextmenu.prevent="$refs.menu.open"
          v-if="!!canvas.length"
          @dragover="dragover"
          @drop="drop"
        >
          <editor-element />
          <page
            :designWidth="designWidth"
            :designHeight="designHeight"
            :canvasWidth="canvasWidth"
            :canvasHeight="canvasHeight"
          />
          <!-- <scale-line :positionList="positionList"></scale-line> -->
        </div>
        <div class="slider">
          <div class="inner">
            <img
              src="../assets/images/minus.svg"
              style="margin-right:10px;"
              @click="scaleSmall"
            />
            <el-slider
              :value="scaleRate * 100"
              @input="handleScale"
              :min="20"
              :max="100"
              :step="10"
            ></el-slider>
            <img
              src="../assets/images/plus.svg"
              style="margin-left:10px;"
              @click="scaleLarge"
            />
            <span>{{ scaleRate * 100 }}%</span>
            <span class="inner-size">模板尺寸</span>
            <el-input
              size="mini"
              :value="designWidth"
              @input="changeCanvas($event, 'designWidth')"
            ></el-input>
            x
            <el-input
              size="mini"
              :value="designHeight"
              @input="changeCanvas($event, 'designHeight')"
            ></el-input>
          </div>
        </div>
        <p
          v-if="!canvas.length"
          style="color:rgba(0,0,0,.65);position:absolute;left:50%;top:50%;font-size:24px;transform:translate(-50%, -50%)"
        >
          请选择一个模板
        </p>
      </div>
      <div id="attribute-panel">
        <div class="tab-content">
          <p class="panel-title">图片编辑</p>
          <attribute-panel />
        </div>
      </div>
      <context-menu class="right-menu" ref="menu">
        <div :class="{ item: true, disabled: !selected.id }" @click="moveTop">
          置顶
        </div>
        <div :class="{ item: true, disabled: !selected.id }" @click="moveUp">
          上移一层
        </div>
        <div :class="{ item: true, disabled: !selected.id }" @click="moveDown">
          下移一层
        </div>
        <div
          :class="{ item: true, disabled: !selected.id }"
          @click="moveBottom"
        >
          置底
        </div>
        <div class="divider"></div>
        <div
          :class="{ item: true, disabled: !selected.id }"
          @click="removeItem"
        >
          删除
        </div>
      </context-menu>
    </div>
    <el-dialog title="保存" :visible.sync="dialogVisible" width="60%">
      <div class="form">
        <el-form
          ref="form"
          :model="form"
          :rules="rules"
          label-width="120px"
          label-position="left"
        >
          <el-form-item label="保存为">
            <el-radio-group v-model="form.design_type" size="lage">
              <el-tooltip
                class="item"
                effect="dark"
                placement="right"
                v-for="item in designTypeOptions"
                :key="item.value"
                :disabled="item.value !== 0"
              >
                <div slot="content">
                  1.模板是指带有可替换标记的图片或/视频<br/>2.利用模板可批量生成创意或者程序化投放中实时生成创意
                </div>
                <el-radio-button :label="item.value" :value="item.value">
                  {{ item.name }}
                </el-radio-button>
              </el-tooltip>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="名称" prop="name">
            <el-input v-model="form.name"></el-input>
          </el-form-item>
          <div v-show="form.design_type === 0">
            <label style="margin-bottom:10px;display: block"
              >选择适配类型</label
            >
            <el-form-item label="" prop="resizeType">
              <el-radio-group v-model="form.resizeType">
                <el-radio :label="1"
                  >坑位尺寸（ *
                  不校验素材尺寸，只要图片数量满足坑位数量模板即可生效）</el-radio
                >
                <el-radio :label="2"
                  >模板尺寸（ *
                  素材尺寸和图片数量需完全等于模板尺寸及坑位数量，模板才生效）</el-radio
                >
              </el-radio-group>
            </el-form-item>
            <!-- <label style="margin-bottom:10px;display: block">模板组</label>
                    <el-form-item label="" prop="type">
                        <el-radio-group v-model="type">
                            <el-radio :label="1">选择已有模板组</el-radio>
                            <el-radio :label="0">创建一个新模板组</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="组名称" v-if="type===0" prop="groupName">
                        <el-input v-model="form.groupName"></el-input>
                    </el-form-item>
                    <el-form-item label="选择组" v-else prop="groupId">
                        <el-select v-model="form.groupId" placeholder="请选择">
                            <el-option
                                    v-for="item in group"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item> -->
            <label style="margin-bottom:10px;display: block">默认行为</label>
            <el-form-item label="" prop="defaultAction">
              <el-radio-group v-model="form.defaultAction">
                <el-radio :label="0">容错图</el-radio>
                <el-radio :label="1">跳转</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="容错图" prop="defaultPath">
              <div class="image-list">
                <div v-for="(keyName, index) in keys" :key="keyName">
                  <label>画布{{ index + 1 }}</label>
                  <upload-image v-model="form.defaultPath[keyName]" />
                </div>
              </div>
            </el-form-item>
          </div>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveTemplateHandler">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import AttributeContent from 'components/AttributeContent';
import ResourcePanel from 'components/ResourcePanel';
import ElementPanel from 'components/ElementPanel';
import userMaterialPanel from 'components/userMaterialPanel';
import ElementEditor from 'components/editor/ElementEditor';
import { Message } from 'element-ui';
import _ from 'lodash';
import drag from 'mixins/drag';
import UploadImage from 'components/UploadImage';
import Mousetrap from 'mousetrap';
import Axios from 'utils/axios';
import keyboardJS from 'keyboardjs';
import { isMac } from 'utils/helper';
import { DESIGN_TYPE_OPTIONS } from 'constant/design';

export default {
  mixins: [drag],
  data() {
    return {
      form: {
        source: 0,
        defaultAction: 0,
        resizeType: 1,
        groupId: null,
        groupName: '',
        name: '',
        design_type: 1,
        defaultPath: {}
      },
      rules: {
        name: [{ required: true, message: '请输入名称', trigger: 'blur' }],
        defaultPath: [{ required: true, message: '请上传容错图' }]
      },
      type: 0,
      designTypeOptions: DESIGN_TYPE_OPTIONS,
      saveNew: false,
      dialogVisible: false,
      change: false,
      isDragging: false,
      container: null,
      interval: null,
      activeMenuIndex: null,
      position: null,
      scrollTop: 0
    };
  },
  components: {
    UploadImage,
    'editor-element': ElementEditor,
    'attribute-panel': AttributeContent,
    'resource-panel': ResourcePanel,
    'element-panel': ElementPanel,
    'user-material-panel': userMaterialPanel
  },
  watch: {},
  computed: {
    designWidth() {
      return this.$store.state.designWidth;
    },
    designHeight() {
      return this.$store.state.designHeight;
    },
    scaleRate() {
      return this.$store.state.scaleRate;
    },
    canvas() {
      return this.$store.state.canvas || [];
    },
    keys() {
      return this.$store.state.keys || [];
    },
    template() {
      return this.$store.state.tpl;
    },
    activeKey() {
      return this.$store.state.activeKey;
    },
    canvasWidth() {
      return this.designWidth * this.scaleRate;
    },
    canvasHeight() {
      return this.designHeight * this.scaleRate;
    },
    pageStyle() {
      return {
        width: this.canvasWidth + 'px',
        height: this.canvasHeight + 'px'
      };
    },
    selected() {
      return this.$store.state.selected;
    },
    list() {
      return this.$store.state.basic.list || [];
    },
    total() {
      return this.$store.state.basic.total;
    },
    limit() {
      return this.$store.state.basic.pageSize;
    },
    group() {
      return this.$store.state.group.list || [];
    }
  },
  beforeDestroy() {
    this.$store.commit('update', {
      designWidth: 0,
      designHeight: 0,
      scaleRate: 1,
      keys: [],
      canvas: [],
      clipboard: null,
      selected: {}
    });
    keyboardJS.reset();
  },
  mounted() {
    this.editorPaste();
    this.editorDelete();
    if (this.$route.params.id) {
      this.fetchTemplate();
    } else if (this.$route.query.tpl) {
      Axios.get('/admin/template/detail', {
        params: {
          id: this.$route.query.tpl
        }
      }).then(res => {
        this.$store.commit('load_template', res);
      });
    }
    Mousetrap.bind('up', e => {
      this.$store.commit('move_short_up');
      e.preventDefault();
    });
    Mousetrap.bind('right', e => {
      this.$store.commit('move_short_right');
      e.preventDefault();
    });
    Mousetrap.bind('down', e => {
      this.$store.commit('move_short_down');
      e.preventDefault();
    });
    Mousetrap.bind('left', e => {
      this.$store.commit('move_short_left');
      e.preventDefault();
    });
    Mousetrap.bind('shift+up', e => {
      this.$store.commit('move_large_up');
      e.preventDefault();
    });
    Mousetrap.bind('shift+right', e => {
      this.$store.commit('move_large_right');
      e.preventDefault();
    });
    Mousetrap.bind('shift+down', e => {
      this.$store.commit('move_large_down');
      e.preventDefault();
    });
    Mousetrap.bind('shift+left', e => {
      this.$store.commit('move_large_left');
      e.preventDefault();
    });

    this.fetchPublicTemplate();
    this.container = this.$refs.canvas;
  },
  methods: {
    drop() {
      const data = event.dataTransfer.getData('data');
      const width = event.dataTransfer.getData('width');
      const height = event.dataTransfer.getData('height');
      if (!_.isEmpty(data)) {
        this.$store.dispatch('elm_add', {
          type: 'image',
          width: parseInt(width, 10),
          height: parseInt(height, 10),
          isDynamic: 0,
          isCover: 0,
          x: event.offsetX,
          y: event.offsetY,
          content: data
        });
      }
    },
    dragover(event) {
      event.preventDefault();
    },
    editorPaste() {
      let _this = this;
      keyboardJS.bind(isMac() ? 'command + v' : 'ctrl + v', function() {
        const clipboard = _this.$store.state.clipboard;
        if (clipboard) {
          _this.$store.dispatch('elm_add', {
            type: clipboard.type,
            width: clipboard.width,
            height: clipboard.height,
            isDynamic: clipboard.isDynamic,
            isCover: clipboard.isCover,
            x: _this.canvasWidth / 2,
            y: _this.canvasHeight / 2,
            content: clipboard.content,
            style: clipboard.style
          });
        }
      });
    },
    cancelClipboard() {
      keyboardJS.pause();
    },
    resumeClipboard() {
      keyboardJS.resume();
    },
    editorDelete() {
      let _this = this;
      keyboardJS.bind('backspace', null, function() {
        const selected = _this.$store.state.selected;
        if (selected) {
          _this.$store.commit('elm_remove', {
            id: selected.id
          });
        }
      });
    },
    handleScale(rate) {
      this.$store.commit('update', {
        scaleRate: rate / 100
      });
    },
    goHome() {
      this.$router.push('/template/list');
    },
    updateSource(value) {
      this.form.source = value;
      if (this.type === 1) {
        this.form.groupId = null;
        this.updateGroup();
      }
    },
    updateGroup() {
      this.$store.dispatch('group/fetch', {
        source: this.form.source
      });
    },
    fetchPublicTemplate() {
      this.$store.dispatch('basic/fetch', {});
    },
    fetchTemplate(id) {
      this.$store.dispatch('template/fetchOne', {
        id: id || this.$route.params.id
      });
    },
    getSubmitTemplate(defaultPath = {}) {
      let template = {};
      this.keys.forEach(keyName => {
        template[keyName] = {
          ...this.template[keyName],
          defaultPath: defaultPath[keyName],
          list: this.template[keyName].list.map(item => {
            let { width, height, x, y, ...data } = item;
            x -= width / 2;
            y -= height / 2;
            return {
              minPoint: {
                x: Math.round(x),
                y: Math.round(y)
              },
              maxPoint: {
                x: Math.round(x + width),
                y: Math.round(y + height)
              },
              width: Math.round(width),
              height: Math.round(height),
              ...data
            };
          })
        };
      });

      return template;
    },
    saveTemplate() {
      this.$store.commit('save_canvas');
      this.updateGroup();
      if (this.$route.params.id) {
        const data = this.$store.state.template.data || {};
        //设置初始值
        this.type = 1;
        this.form.design_type = 1;
        this.form.resizeType = data.resizeType;
        this.form.groupId = data.groupId;
        this.form.groupName = data.groupName;
        this.form.name = data.name;
        this.form.defaultAction = data.defaultAction;
        let defaultPath = {};
        Object.keys(data.content).forEach(keyName => {
          defaultPath[keyName] = data.content[keyName].defaultPath;
        });
        this.form.defaultPath = defaultPath;
      }
      this.saveNew = false;
      this.dialogVisible = true;
    },
    saveAnother() {
      this.updateGroup();
      this.saveNew = true;
      this.form.design_type = 1;
      this.dialogVisible = true;
    },
    saveTemplateHandler() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.form.source = 1;
          this.form.groupId = 0;
          const { defaultPath, ...formData } = this.form;
          this.$store.commit('save_canvas');

          const content = this.getSubmitTemplate(defaultPath);
          // console.log(content)

          const sizes = Object.keys(content).map(key => {
            return content[key].width + '-' + content[key].height;
          });

          let valid = true,
            i = 1;

          while (sizes[i]) {
            if (sizes[i] !== sizes[0]) {
              valid = false;
              break;
            }
            i++;
          }

          if (!valid) {
            return this.$message.error('模板尺寸不同');
          }

          this.$store
            .dispatch('template/save', {
              id:
                this.saveNew || !this.$route.params.id
                  ? null
                  : +this.$route.params.id,
              ...formData,
              content
            })
            .then(res => {
              if (res.id) {
                this.$router.replace('/template/list');
                this.fetchTemplate(res.id);
              }
              this.dialogVisible = false;
              Message.success('保存成功');
            });
        }
      });
    },
    switchCanvas(key) {
      this.$store.commit('switch_canvas', { key });
    },
    cancelSelect() {
      this.$store.dispatch('elm_unselect');
    },
    addText() {
      this.$store.dispatch('elm_add', {
        type: 'text',
        width: 100,
        height: 50,
        x: this.canvasWidth / 2,
        y: this.canvasHeight / 2,
        content: '双击编辑文字',
        isDynamic: 0,
        isCover: 0,
        style: {
          fontSize: 20
        }
      });
    },
    addImage() {
      this.$store.dispatch('elm_add', {
        type: 'image',
        width: 200,
        height: 200,
        isDynamic: 0,
        isCover: 0,
        x: this.canvasWidth / 2,
        y: this.canvasHeight / 2,
        content: ''
      });
    },
    addCanvas() {
      this.$store.commit('add_canvas');
    },
    scaleSmall() {
      this.$store.commit('update', {
        scaleRate: +Math.max(0.2, this.scaleRate - 0.1).toFixed(2)
      });
    },
    scaleLarge() {
      this.$store.commit('update', {
        scaleRate: +Math.min(1, this.scaleRate + 0.1).toFixed(2)
      });
    },
    removeCanvas(key) {
      this.$store.commit('remove_canvas', { key });
    },
    moveTop() {
      this.$store.commit('elm_move_top', { id: this.selected.id });
    },
    moveBottom() {
      this.$store.commit('elm_move_bottom', { id: this.selected.id });
    },
    moveUp() {
      this.$store.commit('elm_move_up', { id: this.selected.id });
    },
    moveDown() {
      this.$store.commit('elm_move_down', { id: this.selected.id });
    },
    undoAction() {
      this.$store.commit('undo_history');
    },
    redoAction() {
      this.$store.commit('redo_history');
    },
    removeItem() {
      this.$store.commit('elm_remove', { id: this.selected.id });
    },

    changeCanvas(value, type) {
      this.$store.commit('update', {
        [type]: +value
      });
    }
  }
};
</script>
<style lang="scss">
.el-tabs--left .el-tabs__header.is-left {
  width: 51px;
  background-image: -webkit-linear-gradient(right, #011d4e, #000835);
  margin-right: 0;
}

.el-tabs__item {
  color: #ffffff;
  font-size: 12px;
  line-height: 17px;
  margin-bottom: 12.56px;
}

.el-tabs__nav {
  margin-top: 29.56px;
}

.el-tabs__nav-wrap::after {
  display: none;
}

.el-tabs__active-bar {
  display: none;
}
</style>
<style lang="scss" scoped>
@import '../stylesheets/base';

#canvas-tab {
  width: 100%;
  height: 40px;
  display: flex;
  background-color: #efefef;
  position: relative;
  z-index: 2;

  > .tab {
    flex: 1;
    display: flex;
    justify-content: space-between;
    padding: 0 10px;
    line-height: 40px;
    border-left: 1px solid #d8d8d8;
    border-bottom: 1px solid #d8d8d8;

    .close {
      cursor: pointer;
    }

    &:first-child {
      border-left: 0;
    }

    &.active {
      background: #f8f8f8;
      border-bottom: 0;
    }
  }
}
.tabs-title {
  display: flex;
  flex-direction: column;
  align-items: center;
  svg {
    display: block;
    width: 20px;
    height: 20px;
  }
}
.image-list {
  width: 100%;
  overflow: hidden;
  display: flex;

  > * {
    label {
      min-width: 50px;
    }

    margin-right: 20px;
    display: flex;
  }
}

#page {
  background: #ffffff;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

.button-group {
  display: flex;
  justify-content: space-around;
}

.btn-group {
  min-width: 130px;
  display: flex;
  justify-content: space-between;
}

.dialog-footer {
  text-align: center !important;
}

.select-mask {
  position: absolute;
  border: 1px dashed $green;
  background-color: rgba(0, 205, 154, 0.3);
}

.toolbar {
  position: absolute;
  top: 170px;
  right: 0;
  z-index: 999;

  > .action-button {
    width: 36px;
    height: 36px;
    padding: 7px;
    box-sizing: border-box;
    margin-bottom: 6px;
    background-color: #4a4a4a;
    border-radius: 6px;
    cursor: pointer;

    &.disabled {
      pointer-events: none;
      opacity: 0.3;
    }

    &:active {
      opacity: 0.8;
    }

    > i {
      color: #fff;
      display: block;
      width: 22px;
      height: 22px;
      font-size: 22px;
    }

    &:last-child {
      margin-bottom: 0;
    }
  }
}

.slider {
  left: 0;
  bottom: 0;
  width: 100%;
  border-top: 1px solid #d8d8d8;
  position: absolute;
  background: #efefef;

  .inner {
    margin: 0 auto;
    width: 570px;
    height: 40px;
    display: flex;
    align-items: center;

    > span {
      flex: none;
      margin-left: 20px;
    }

    > :global(.el-slider) {
      width: 200px;
      flex: none;
    }

    :global(.el-slider__bar),
    :global(.el-slider__runway) {
      background: #d8d8d8;
    }

    :global(.el-slider__button) {
      width: 12px;
      height: 12px;
      background: #4a90e2;
      border: 0;
      margin: 5px;
    }

    .inner-size {
      font-size: 12px;
      margin-right: 5px;
    }
  }
}
</style>
